export default class DtoLocationLink {
    constructor(obj) {
        this.idStation = obj.idStation
        this.projection = obj.projection
        this.x = obj.x
        this.y = obj.y
        this.z = obj.z
        this.precision = obj.precision
    }
}